import { render, staticRenderFns } from "./HouseAssessmentList.vue?vue&type=template&id=d8b61e7c"
import script from "./HouseAssessmentList.vue?vue&type=script&lang=js"
export * from "./HouseAssessmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports